<template>
    <div :class="`EventIndex__item`">
        <div class="EventIndex__item__head">
            <h2 class="EventIndex__item__tema">
                <a :href="url(`/akce/${event.id}`)">{{ event.tema }}</a>
            </h2>
            <div :class="[
                'EventIndex__item__typ',
                `EventIndex__item__typ--${event.typ}`
            ]" v-text="event.typ_nazev"></div>
        </div>

        <div class="EventIndex__item__konani" v-html="konani"></div>

        <div class="EventIndex__item__perex">
            {{ event.perex }}
        </div>
    </div>
</template>

<script>
export default {

    props: [
        'data'
    ],

    computed: {
        konani() {
            let spacer = ' <span class="EventIndex__item__konani__spacer"></span> ';
            let konani = this.event.dat_konani_cz
                + spacer
                + this.event.misto_konani;

            if (this.event.rozsah) {
                konani = konani
                    + spacer
                    + this.event.rozsah
                    + 'min';
            }

            return konani;

        }
    },

    data() {
        return {
            event: this.data,
            auth: window.App.auth
        }
    }
}
</script>
